// ============================================================
// GATILHOS DISPONÍVEIS PARA OS BOTÕES DO EURUS/ BOTOES DO TEMA, BOTOES ONDE É POSSIVEL EM SECOES COMO IMAGEM COM TEXTO...ETC NAO é o Botao PRINCIPAL DA PAGINA DO PRODUTO
// ------------------------------------------------------------
// Para usar, coloque um dos links abaixo no campo
// "Link do primeiro botão" no editor do tema:
//
//  #add-to-cart → Adiciona ao carrinho (abre mini-cart)
//  #buy-now     → Vai direto pro checkout
// ============================================================

// Gatilho: #add-to-cart
document.addEventListener("click", function(e) {
  const link = e.target.closest('a[href="#add-to-cart"]');
  if (!link) return;
  e.preventDefault();

  const botaoNativo = document.querySelector('button[name="add"]');
  if (botaoNativo) botaoNativo.click();
});


// Gatilho: #buy-now
document.addEventListener("click", function(e) {
  const link = e.target.closest('a[href="#buy-now"]');
  if (!link) return;
  e.preventDefault();

  const botaoCheckout = document.querySelector('shopify-buy-it-now-button button');
  if (botaoCheckout) botaoCheckout.click();
});
